<template>
  <div class="list-item with-icon mt-2">
    <v-list-item-avatar
      :class="{ willLose }"
      min-width="50px"
      height="50px"
      @click="$emit('select')"
    >
      <v-img height="20px" contain src="@/assets/svg/user-icon.svg" />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex flex-column">
            <span class="font-weight-bold">{{ user | fullName }}</span>
            <span class="secondary-text">{{ roles }}</span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { getRoles } from "@/utils/users";

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    willLose: Boolean
  },
  computed: {
    roles() {
      return this.user ? getRoles(this.user.roles) : "";
    }
  }
};
</script>

<style lang="scss">
.users {
  .list-item .v-avatar.v-list-item__avatar {
    background-color: #17d99c41;
    border-radius: 50%;
  }
  .list-item .v-avatar.v-list-item__avatar.willLose {
    background-color: #fde7ec;
  }
  .list-item {
    padding: 0;
  }
}
</style>
